import { Component, Input } from '@angular/core';
import { ProductTypeCode } from '../../models/application-general.model';

@Component({
  standalone: false,
  selector: 'app-renewal-badge',
  templateUrl: './renewal-badge.component.html',
  styleUrls: ['./renewal-badge.component.scss']
})
export class RenewalBadgeComponent{
  @Input()
  productTypeCode?: ProductTypeCode;

  @Input()
  isRenewalOptIn?: boolean;

  @Input()
  leaseEndDate?: Date;

  @Input()
  programLeaseEndDate?: Date;

  ProductTypeCode = ProductTypeCode;

  constructor() { }
}
